import { render, staticRenderFns } from "./BlockDates.vue?vue&type=template&id=dd719cd4&scoped=true"
import script from "./BlockDates.vue?vue&type=script&lang=js"
export * from "./BlockDates.vue?vue&type=script&lang=js"
import style0 from "./BlockDates.vue?vue&type=style&index=0&id=dd719cd4&prod&lang=scss&scoped=true"
import style1 from "./BlockDates.vue?vue&type=style&index=1&id=dd719cd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd719cd4",
  null
  
)

export default component.exports